import React from 'react';
import { Link } from 'react-router-dom';
import { formattedDate, dataInformadaMaiorQueHoje } from '../../services/utils';
import Timeline from '../Timeline';
import TimelineItem from '../Timeline/TimelineItem';

import './styles.css';

const Chamamento = ({ className, cd_processo_seletivo, ds_processo_seletivo, datasProcesso, chamamentos = [] }) => {
    const chamamentoAtual = chamamentos[0];

    if (!chamamentoAtual) {
        return <></>;
    }

    return (
        <div className={`${className} card`} style={{ marginBottom: '0' }}>
            <div className="card-header" style={{ minHeight: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                <h5 className="mb-0 card-title card-header--lg" style={{ fontSize: '1.4em' }}>
                    {ds_processo_seletivo}
                </h5>
            </div>
            <div className="card-body">
                <div className="datas-processo">
                    {datasProcesso.map(data => {
                        return (
                            <div key={data.tipo} className={data.info ? '' : 'disabled'}>
                                <strong>{data.tipo}</strong>
                                <br />
                                {data.info ?? 'Em breve'}
                            </div>
                        );
                    })}
                </div>

                <Link className="btn btn-primary mt-3 w-100" to={`/documentos/${cd_processo_seletivo}`}>
                    Acessar chamamento
                </Link>

                <hr />

                <h3 style={{ color: 'var(--global-cor-furg-laranja)', marginBottom: '15px' }}>{chamamentoAtual.ds_chamamento}</h3>

                <Timeline>
                    {chamamentoAtual.etapas.map((etapa, index) => (
                        <TimelineItem
                            key={`${chamamentoAtual.id_calendario_prematricula}_${index}`}
                            disabled={(etapa.dt_fim && !dataInformadaMaiorQueHoje(etapa.dt_fim)) || (!etapa.dt_fim && !dataInformadaMaiorQueHoje(etapa.dt_inicio))}
                        >
                            <strong>{etapa.ds_etapa}</strong>
                            <br />

                            <>{etapa.dt_fim ? `de ${formattedDate(etapa.dt_inicio)} até ${formattedDate(etapa.dt_fim)}` : `a partir de ${formattedDate(etapa.dt_inicio)}`}</>
                        </TimelineItem>
                    ))}
                </Timeline>
            </div>
        </div>
    );
};

export default Chamamento;
